import React, { useState, useEffect } from 'react'

export default function MainPresentation() {
  const [cmsData, setCmsData] = useState(null)

  useEffect(() => {
    // Attempt to load from CMS if available
    fetch('/_api/public/v2/content/presentation_page')
      .then((res) => (res.ok ? res.json() : null))
      .then((data) => {
        if (data && data.items && data.items.length > 0) {
          setCmsData(data.items[0])
        }
      })
      .catch(() => {
        // Fallback silently
      })
  }, [])

  return (
    <section id="announcement" className="py-12 sm:py-16 bg-[#0a120d] border-t border-b border-[#183122]">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="mb-10 text-center sm:text-left">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-md bg-[#132419] border border-[#1f3f2a] text-xs font-semibold uppercase tracking-wider text-emerald-300 mb-3">
            <span className="w-1.5 h-1.5 rounded-full bg-amber-400" aria-hidden="true" />
            <span>Midlertidig information · Official Notice</span>
          </div>
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-white tracking-tight">
            Welcome to Biofuel Technology Global or briefly BFT Global!
          </h2>
        </div>

        {/* Verbatim Announcement Card */}
        <div className="bg-[#0f1e15] border border-[#20402c] rounded-2xl p-6 sm:p-10 shadow-xl relative overflow-hidden">
          {/* Subtle top indicator bar */}
          <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-emerald-600 via-emerald-400 to-[#10b981]" />

          <div className="space-y-6 text-neutral-200 text-base sm:text-lg leading-relaxed">
            <p className="text-white font-medium text-lg sm:text-xl leading-relaxed">
              The company deals with several aspects of collecting, preprocessing, and processing lignocellulosic biomass of both silvicultural and agricultural origins into biofuels, biogasses, green chemicals, and biogenic CO2.
            </p>

            <p>
              We will open a homepage presenting our company shortly. In the meantime please contact founder and owner Mr. Torben A. Bonde at{' '}
              <a
                href="mailto:tab@biofuelglobal.dk"
                className="text-emerald-400 font-semibold hover:text-emerald-300 underline underline-offset-4 decoration-emerald-500/50 hover:decoration-emerald-300 transition-colors whitespace-nowrap"
              >
                tab@biofuelglobal.dk
              </a>{' '}
              or co-founder and co-owner Peter Taylor at{' '}
              <a
                href="mailto:pta@biofuelglobal.dk"
                className="text-emerald-400 font-semibold hover:text-emerald-300 underline underline-offset-4 decoration-emerald-500/50 hover:decoration-emerald-300 transition-colors whitespace-nowrap"
              >
                pta@biofuelglobal.dk
              </a>
            </p>

            <p>
              You are also welcome to consult the homepage of our partner company Kinetic Biofuel –{' '}
              <a
                href="https://www.kineticbiofuel.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-emerald-400 font-semibold hover:text-emerald-300 underline underline-offset-4 decoration-emerald-500/50 hover:decoration-emerald-300 inline-flex items-center gap-1 transition-colors whitespace-nowrap"
              >
                <span>www.kineticbiofuel.com</span>
                <i className="fa-solid fa-arrow-up-right-from-square text-xs" aria-hidden="true" />
              </a>{' '}
              – where Mr. Torben A. Bonde and co-workers may also be contacted at{' '}
              <a
                href="mailto:tab@kineticbiofuel.com"
                className="text-emerald-400 font-semibold hover:text-emerald-300 underline underline-offset-4 decoration-emerald-500/50 hover:decoration-emerald-300 transition-colors whitespace-nowrap"
              >
                tab@kineticbiofuel.com
              </a>
            </p>
          </div>

          {/* Authentic Sign-off Block */}
          <div className="mt-10 pt-8 border-t border-[#1e3c29] flex flex-col sm:flex-row sm:items-end justify-between gap-6">
            <div>
              <p className="text-sm text-neutral-400 font-normal italic mb-2">
                Sincerely yours,
              </p>
              <p className="text-xl font-bold text-white tracking-tight">
                Torben A. Bonde
              </p>
              <p className="text-sm font-semibold text-emerald-400 mt-0.5">
                Biofuel Technology Global
              </p>
              <address className="not-italic text-sm text-neutral-300 mt-2 space-y-0.5">
                <div>Bredkaer Parkvej 58</div>
                <div>8250 Egaa, Denmark</div>
              </address>
            </div>

            <div className="bg-[#14281c] border border-[#234b32] rounded-xl px-4 py-3 text-xs text-neutral-300 max-w-xs">
              <div className="flex items-center gap-2 font-semibold text-emerald-300 mb-1">
                <i className="fa-solid fa-circle-info text-xs" aria-hidden="true" />
                <span>Notice</span>
              </div>
              <p className="text-[12px] leading-normal text-neutral-300">
                Official website under active development. Direct email channels are open for inquiries and technical collaboration.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
